import { Component, OnInit} from '@angular/core';
import { AppService } from '../../../app.service';

@Component({
  selector: 'app-setup-models',
  templateUrl: './setup-models.component.html',
  styleUrls: ['./setup-models.component.scss']
})
export class SetupModelsComponent implements OnInit {

  constructor(
    private _appService: AppService,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Model Setup');
  }

}
